/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: block;
}

.qds-button,
.qds-nav-list-item,
.qds-texts {
  display: flex;
}

.qds-button,
.qds-texts {
  flex: 1 0;
}

.qds-icon,
.qds-text {
  color: var(--qds-theme-title);
}

.qds-button {
  align-items: center;
  appearance: none;
  background: none;
  border: none;
  cursor: pointer;
  text-align: initial;

  &:focus-visible {
    outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
    border-radius: var(--qds-focus-border-radius);
  }

  &:not(.qds-selected) {
    &:hover {
      background-color: var(--qds-theme-interactive-background-hover);
    }

    &:active {
      background-color: var(--qds-theme-interactive-background-pressed);
    }
  }
}

.qds-disabled {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
}

.qds-subtext {
  color: var(--qds-theme-subtitle);
}

.qds-texts {
  flex-direction: column;
}

[data-size='small'] {
  &.qds-button {
    gap: var(--qds-list-item-small-gap-internal);
    min-height: var(--qds-list-item-small-height);
    padding-block: var(--qds-list-item-small-padding-vertical);
    padding-inline: var(--qds-list-item-small-padding-horizontal);
  }

  & > .qds-icon {
    font-size: var(--qds-list-item-small-icon-size);
  }

  & > .qds-texts {
    gap: var(--qds-list-item-small-titles-gap);
  }

  & .qds-text {
    font: var(--qds-list-item-small-title);
  }

  & .qds-subtext {
    font: var(--qds-list-item-small-subtitle);
  }
}

[data-size='standard'] {
  &.qds-button {
    gap: var(--qds-list-item-standard-gap-internal);
    min-height: var(--qds-list-item-standard-height);
    padding-block: var(--qds-list-item-standard-padding-vertical);
    padding-inline: var(--qds-list-item-standard-padding-horizontal);
  }

  & > .qds-icon {
    font-size: var(--qds-list-item-standard-icon-size);
  }

  & > .qds-texts {
    gap: var(--qds-list-item-standard-titles-gap);
  }

  & .qds-text {
    font: var(--qds-list-item-standard-title);
  }

  & .qds-subtext {
    font: var(--qds-list-item-standard-subtitle);
  }
}

[data-size='large'] {
  &.qds-button {
    gap: var(--qds-list-item-large-gap-internal);
    min-height: var(--qds-list-item-large-height);
    padding-block: var(--qds-list-item-large-padding-vertical);
    padding-inline: var(--qds-list-item-large-padding-horizontal);
  }

  & > .qds-icon {
    font-size: var(--qds-list-item-large-icon-size);
  }

  & > .qds-texts {
    gap: var(--qds-list-item-large-titles-gap);
  }

  & .qds-text {
    font: var(--qds-list-item-large-title);
  }

  & .qds-subtext {
    font: var(--qds-list-item-large-subtitle);
  }
}

.qds-selected {
  &.qds-nav-list-item {
    background-color: var(
      --qds-theme-navigation-subsection-standard-background
    );

    &::after {
      background-color: var(--qds-theme-signature-color-default);
      border-radius: var(--qds-signature-line-connection-cap-radius);
      content: '';
      cursor: pointer;
      margin-right: calc(-1 * var(--qds-signature-line-connection-width) / 2);
      width: var(--qds-signature-line-connection-width);
    }
  }

  & .qds-icon {
    color: var(--qds-theme-signature-color-default);
  }

  &[data-size='small'] .qds-text {
    font: var(--qds-list-item-small-title-emphasized);
  }

  &[data-size='standard'] .qds-text {
    font: var(--qds-list-item-standard-title-emphasized);
  }

  &[data-size='large'] .qds-text {
    font: var(--qds-list-item-large-title-emphasized);
  }
}
